import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import '../../styles/admin-dashboard.css';

const AdminLayout = () => {
    return (
        <div className="admin-layout-v2">
            <Sidebar />
            <main className="admin-main-v2">
                <Outlet />
            </main>
        </div>
    );
};

export default AdminLayout;
